export default __webpack_public_path__ + "media/images/ui-icons_444444_256x240-2bf13b17.png";